<template>
  <div class="create-form">
    <div class="acivity-right">
      <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="110px">
        <el-form-item label="活动名称：" prop="name">
          <el-input v-model="formInline.name" placeholder="请输入活动名称（不能超过50字）" maxlength="50" class="inputwidth"></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="date">
          <el-date-picker v-model="formInline.date" @change="dateChange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-select v-model="formInline.type" placeholder="请选择类型" @change="typeChange">
            <el-option v-for="item in typeOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换产品：" prop="products"  v-if="type === 0">
          <el-input v-model="formInline.products" placeholder="请填写可兑换产品，多个商品以“；”区割" maxlength="10" class="inputwidth"></el-input>
        </el-form-item>
        <el-form-item label="代金券金额：" v-if="type === 1">
          <el-input v-model="formInline.money_min" class="x_input"></el-input>
          &nbsp;- &nbsp;
          <el-input v-model="formInline.money_max" class="x_input"></el-input>
        </el-form-item>
        <el-form-item label="投放数量：" prop="put_number">
          <el-input v-model="formInline.put_number" placeholder="请输入投放数量" type="number" min="0"></el-input>
        </el-form-item>
        <el-form-item label="领取规则：">
          每人限领 <el-input v-model="formInline.receivenum" placeholder="0代表不限制" type="number" min="0" style="width: 120px;"></el-input> 张，0代表不限制
        </el-form-item>
        <el-form-item label="使用时间：">
          <el-radio-group v-model="formInline.validitytype">
            <el-radio :label="0">当日生效</el-radio>
            <el-radio :label="1">次日生效</el-radio>
          </el-radio-group>
          <br/>
          有效天数：
          <el-input v-model="formInline.validitydays" placeholder="" type="number" min="0" style="width: 120px;"></el-input> 天，0代表有效期至活动结束
        </el-form-item>
        <el-form-item label="使用数量：">
          每店每日限核销：<el-input v-model="formInline.storeusenum" placeholder="" type="number" min="0" style="width:120px; padding-bottom: 3px;"></el-input> 张
          <br />
          每店每日限核销：<el-input v-model="formInline.storeusemoney" placeholder="" type="number" min="0" style="width:120px;padding-bottom: 3px;"></el-input> 元
          <br />
          &nbsp;&nbsp;&nbsp; 每人每日限用：<el-input v-model="formInline.usenum" placeholder="" type="number" min="0" style="width:120px;padding-bottom: 3px;"></el-input> 张
          <br />
          &nbsp;&nbsp;&nbsp; 每人每日限用：<el-input v-model="formInline.usemoney" placeholder="" type="number" min="0" style="width:120px;padding-bottom: 3px;"></el-input> 元
        </el-form-item>
        <el-form-item label="使用范围：">
          <el-select filterable v-model="formInline.rangegroup" placeholder="请选择">
            <el-option v-for="item in rangegroups" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用区域：">
          <template>
            <el-cascader size="large" :options="options" v-model="selectedOptions"  @change="handleChange">
            </el-cascader>
          </template>
        </el-form-item>
      </el-form>
      <div style="width:190px;margin: 0 0 20px 40%;" class="interface_btn">
        <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addCoupons()">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { API_HOST, API_HOST_JAVA_SET } from '@/api/local'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
import { getGroups,  createCoupons } from '@/api/yunzhong.js'
export default {
  name: 'add-coupons',
  data() {
    return {
      options: regionDataPlus, //区域
      selectedOptions: [],
      rangegroups: [],
      typeOptions: [
        {
          value: 0,
          label: '兑换券'
        },
        {
          value: 1,
          label: '代金券'
        }
      ],
      type: 0,
      formInline: {
        name: '',
        date: [],
        start_time: '',
        end_time: '',
        type: 0,
        products: '',
        money_min: 0,
        money_max: 0,
        receivenum: 0,
        validitytype: 0,
        validitydays: 0,
        storeusenum: 0,
        storeusemoney: 0,
        usenum: 0,
        usemoney: 0,
        rangegroup: null,
        province: '',
        city: '',
        district: '',
        put_number: 0,
      },
      rules: {
        activity_type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入投放数量', trigger: 'blur' }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start_time.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end_time.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
    }
  },
  methods: {
    typeChange(v){
      this.type = v
    },
    handleChange(value){
      //console.log(value)
      this.formInline.province = value[0]
      this.formInline.city = value[1]
      this.formInline.district = value[2]
    },
    addCoupons() {
      if(this.formInline.type == 0){
        this.formInline.money_min = 0
        this.formInline.money_max = 0
      }
      else{
        this.formInline.products = ''
      }
      createCoupons(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/coupons')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange(value) {
      if (value) {
        this.formInline.start_time = value[0]
        this.formInline.end_time = value[1]
      } else {
        this.formInline.start_time = ''
        this.formInline.end_time = ''
      }
    },
    // 获取群组
    getGroupList() {
      getGroups().then((res) => {
        //console.log(res.data.result.list)
        if(res.data.code == 200) {
          for (let item of res.data.result.list) {
            this.rangegroups.push({
              label: item.name,
              value: item.id
            })
          }
        }
        else{
          console.log(res.data.error)
        }
      })
    }
  },
  created() {
    this.getGroupList()
  }
}

</script>
<style scoped>
.create-form {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-right {
  margin: 20px auto;
  width: 100%;
  align-items: center;
  display: block;
  justify-content: center;
}
.inputwidth{
  width: 370px;
}
.acivity-content-form {
  width: 534px;
  text-align: left;
  margin: auto;
}

.acivity-content-form .el-form-item__content {
  width: 300px;
}

.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.x_input{
  width:172px!important;
}
</style>
